import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["updateCertInput", "updateCertMessage"]

  initialize() {
    Multiset.updateSelected("#options-container", "#selected-options");
  }

  removeMapping(event) {
    var el = document.getElementById(event.currentTarget.dataset.id);
    if (el) {
      el.remove();
    }
  }

  selectAll() {
    Multiset.toggleCheckAll("#options-container", true);
    Multiset.updateSelected("#options-container", "#selected-options");
  }

  selectNone() {
    Multiset.toggleCheckAll("#options-container", false);
    Multiset.updateSelected("#options-container", "#selected-options");
  }

  updateSelected() {
    Multiset.updateSelected("#options-container", "#selected-options");
  }

  showUpdateCert() {
    this.updateCertInputTarget.classList.remove('hidden');
    this.updateCertMessageTarget.classList.add('hidden');
  }

  hideUpdateCert() {
    this.updateCertInputTarget.classList.add('hidden');
    this.updateCertMessageTarget.classList.remove('hidden');
  }
}